import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  validateAndSubmitSearchForm,
  expandAccordionsByErrorPaths,
  scrollToFirstError,
  useLookupOptions,
} from '@frontend/pricing-search';
import Session, {
  PRESERVED_NON_QM_DOC_LEVEL,
} from '../../../../common/services/Session';
import { PATH_SEARCH_RESULTS } from '../../../../route/constants';
import { searchFormActions } from '../../../../store/searchForm';
import { FooterButtons } from '../../../components/FooterButtons';
import { setLoanInfo } from '../../../components/Form/utils/common';

export const FooterForm = ({
  schema,
  schemaForm,
  accordionFieldMap,
  setActiveAccordions,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loanTerms = useLookupOptions('loanTerms');

  const handleSearchAction = async () => {
    const result = await validateAndSubmitSearchForm({
      schema,
      schemaForm,
      preview: false,
      loanTerms,
    });

    if (result.valid) {
      const nonQMDocLevel =
        result.formData?.borrowerFinancialHistory?.nonQMDocLevel;
      if (nonQMDocLevel && /^\d+$/.test(String(nonQMDocLevel))) {
        try {
          Session.set(PRESERVED_NON_QM_DOC_LEVEL, String(nonQMDocLevel));
        } catch (e) {
          console.error('[FooterForm] failed to preserve nonQMDocLevel', e);
        }
      }
      dispatch(setLoanInfo(result.formData) as any);
      dispatch(searchFormActions.setBannerIsOpen(false));
      navigate(PATH_SEARCH_RESULTS);
    } else {
      dispatch(searchFormActions.setBannerIsOpen(true));

      if (result.errorPaths?.length) {
        const toOpen = expandAccordionsByErrorPaths(
          accordionFieldMap,
          result.errorPaths,
        );
        setActiveAccordions((prev) => ({ ...prev, ...toOpen }));
        scrollToFirstError(result.errorPaths);
      }
    }
  };

  return (
    <FooterButtons
      buttons={[
        {
          type: 'primary',
          text: 'Search',
          onClick: handleSearchAction,
          'data-testid': 'footer-button-search',
        },
      ]}
    />
  );
};
